import {WebSocketFrontendMessageAlertMessage} from '~/shared/src/utilities/modules/webSocket';
import {
    MESSAGE_CLEAR_ALERT,
    MESSAGE_SET_ALERT
} from '~/frontend/src/constants';
import {
    ClearAlertMessageAction
} from '~/frontend/src/actions/message/clearAlertMessage';
import {
    SetAlertMessageAction
} from '~/frontend/src/actions/message/setAlertMessage';


type Action = ClearAlertMessageAction | SetAlertMessageAction;

export type AlertMessageState = WebSocketFrontendMessageAlertMessage[ 'parameters' ] | null;

const relevantActions = [
    MESSAGE_CLEAR_ALERT,
    MESSAGE_SET_ALERT
];

export default function alertMessageReducer( state : AlertMessageState = null, action : Action ) : AlertMessageState {
    if ( relevantActions.includes( action.type ) ) {
        switch ( action.type ) {
            case MESSAGE_CLEAR_ALERT:
                state = null;
                break;

            case MESSAGE_SET_ALERT:
                state = action.message;
                break;
        }
    }

    return state;
}
